// The server also sets an httpOnly cookie for REST calls (so JS can't read
// or leak it), but Socket.io's `teacher:auth {jwt}` event needs the raw
// token in JS - the login response hands it back once for exactly that
// purpose. Stored in localStorage so a projector-connected laptop survives
// an accidental page refresh mid-class without re-login.

const KEY = 'liveClassroom:teacherJwt';

export function getTeacherToken() {
  try {
    return localStorage.getItem(KEY);
  } catch {
    return null;
  }
}

export function setTeacherToken(token) {
  try {
    localStorage.setItem(KEY, token);
  } catch {
    /* no-op */
  }
}

export function clearTeacherToken() {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* no-op */
  }
}
